import React from 'react';
import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
/* replace-start */
import './index.less';
/* replace-end */
class Feature20 extends React.PureComponent {
  render() {
    const { ...tagProps } = this.props;
    const { dataSource } = tagProps;
    delete tagProps.dataSource;
    delete tagProps.isMobile;

    function getItem() {
      const itemLists = dataSource.content.children;
      return itemLists.map((key, index) => {
        const { title, img, icon, content, ...other } = key;
        return (
          <div {...other} key={title.children + index}>
            <div {...img}>
              <img src={img.children} alt="" />
            </div>
            <div className="row">
              <div {...icon}>
                <img src={icon.children} alt="" />
              </div>
              <div {...title}>
                <span dangerouslySetInnerHTML={{ __html: title.children }} />
              </div>
            </div>
            <div className="contene">
              <div {...content}>
                <span dangerouslySetInnerHTML={{ __html: content.children }} />
              </div>
            </div>
          </div>
        );
      }
      );
    }

    return (
      <div
        {...tagProps}
        {...dataSource.wrapper}
      >
        <div {...dataSource.bg} data-edit="image">
          <img src={dataSource.bg.children} width="100%" alt="img" />
        </div>
        <OverPack
          {...dataSource.OverPack}
        >
          <TweenOne
            animation={{
              y: 0,
              duration: 1000,
            }}
            style={{ transform: 'translateY(-80px)' }}
            {...dataSource.title}
          >
            <span dangerouslySetInnerHTML={{ __html: dataSource.title.children }} />
          </TweenOne>
        </OverPack>
        <OverPack
          {...dataSource.OverPack}
        >
          <TweenOne
            animation={{
              y: 0,
              duration: 1000,
            }}
            style={{ transform: 'translateY(80px)' }}
            {...dataSource.content}
          >
            {getItem()}
          </TweenOne>
        </OverPack>

      </div>
    );
  }
}
export default Feature20;
